import {
    apiRequest,
    seminarCreate,
    admindiklatListPegawai
} from "../../../../../../services/adapters/kepegawaian/seminarService"

class CreateRepository {

    fetchCreate = async (query) => {
        return await apiRequest("post", seminarCreate, {
            body: query
        }, true)
    }
    fetchPegawai = async (query) => {
        return await apiRequest("get", admindiklatListPegawai, {
            body: query
        }, true)
    }

}

export default CreateRepository